import TablePagination from '@mui/material/TablePagination';
import './style.scss';

interface Props {
    page: number;
    count: number;
    rowsPerPage: number;
    onPageChange: (page: number) => void;
    onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

function Pagination({ page, count, rowsPerPage, onPageChange, onRowsPerPageChange }: Props) {
    return (
        <TablePagination
            className="Pagination"
            component="div"
            page={page}
            count={count}
            rowsPerPage={rowsPerPage}
            onPageChange={(e, newPage) => onPageChange(newPage)}
            onRowsPerPageChange={onRowsPerPageChange}
        />
    );
}

export default Pagination;
